import type { ComponentPropsWithRef, ReactNode } from 'react';
import { cn } from '../lib/cn';

export const cardStyles = 'rounded-lg border border-border-subtle bg-bg-1';

export function Card({ className, ...props }: ComponentPropsWithRef<'div'>) {
  return <div className={cn(cardStyles, className)} {...props} />;
}

export interface KpiTileProps {
  label: ReactNode;
  value: ReactNode;
  detail?: ReactNode;
  tone?: 'negative' | undefined;
}

/** KPI tile (CLAUDE.md §6.8). */
export function KpiTile({ label, value, detail, tone }: KpiTileProps) {
  return (
    <div className="min-w-0 rounded-lg border border-border-subtle bg-bg-1 px-4 py-3">
      <p className="truncate text-xs text-text-3">{label}</p>
      <p
        className={cn(
          'tabular mt-1 truncate text-lg font-semibold',
          tone === 'negative' && 'text-negative',
        )}
      >
        {value}
      </p>
      {detail !== undefined && <div className="mt-0.5 truncate text-xs text-text-3">{detail}</div>}
    </div>
  );
}
